var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      [
        _c("div", { staticClass: "va-subtitle flex align-center" }, [
          _vm._v(" " + _vm._s(_vm.$t("roomCommands.title")) + " ")
        ]),
        _c(
          "va-card",
          { staticClass: "fit-height mb-6" },
          [
            _c("div", { staticClass: "va-subtitle-s" }, [
              _vm._v(_vm._s(_vm.$t("common.roomName")))
            ]),
            _c("va-text-field", {
              staticClass: "mb-5",
              attrs: {
                label: _vm.$t("common.roomName"),
                dense: "",
                disabled: _vm.room.isMaintenanceExpired
              },
              model: {
                value: _vm.room.name,
                callback: function($$v) {
                  _vm.$set(_vm.room, "name", $$v)
                },
                expression: "room.name"
              }
            }),
            _c(
              "div",
              { staticClass: "d-flex flex-row-reverse" },
              [
                _c("va-button", {
                  attrs: {
                    size: "s",
                    disabled:
                      _vm.sending ||
                      !_vm.room.name ||
                      _vm.room.isMaintenanceExpired,
                    cta: _vm.$t("common.save")
                  },
                  on: { click: _vm.setName }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "va-card mb-6" },
          [
            _c("div", { staticClass: "va-subtitle flex align-center" }, [
              _vm._v(" " + _vm._s(_vm.$t("common.policies")) + " ")
            ]),
            _c("policies-chooser", {
              attrs: {
                policies: _vm.room.policies,
                "is-room": "",
                isAndroid: "true",
                hideIcons: "",
                disabled: _vm.room.isMaintenanceExpired
              }
            })
          ],
          1
        ),
        _c("logging-android", { staticClass: "va-card mb-6" }),
        _c("room-last-commands", { staticClass: "va-card mb-6" })
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }